<main class="h-screen w-full flex flex-row">
  <!-- Sidebar -->
  <div class="w-[14%] h-full bg-white" id="side-bar">
    <app-sidebar class="sidebar"></app-sidebar>
  </div>

  <!-- Main Content Area -->
  <div class="w-[86%] h-full flex flex-col" id="main-content">
    <!-- Header -->
    <app-header></app-header>

    <!-- Content + Footer Container -->
    <div class="flex flex-col flex-1 min-h-0">
      <!-- Main Content (Scrollable) -->
      <div class="flex-1 overflow-y-auto p-5">
        <router-outlet></router-outlet>
      </div>
      <div class="sticky">
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</main>
